import { render, staticRenderFns } from "./oneDetailsDialog.vue?vue&type=template&id=727cf9e8&scoped=true&"
import script from "./oneDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./oneDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./oneDetailsDialog.vue?vue&type=style&index=0&id=727cf9e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727cf9e8",
  null
  
)

export default component.exports